<template>
  <v-card :loading="isLoading">
    <v-card-title>
      Edit Payment Details
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-card-title
            class="pl-0"
          >
            Original values
          </v-card-title>

          <template v-if="hasIbanBefore">
            <v-label>
              IBAN
            </v-label>
            <v-col cols="12">
              <v-row
                v-for="(_, key) in infoBefore.iban_details"
                :key="key"
              >
                <v-text-field
                  v-model="infoBefore.iban_details[key]"
                  :label="key"
                  readonly
                  hide-details
                />
              </v-row>
            </v-col>
          </template>

          <template v-if="hasParamsBefore">
            <v-label>
              Params
            </v-label>
            <v-col cols="12">
              <v-row
                v-for="(_, key) in paramsBefore"
                :key="key"
              >
                <v-text-field
                  v-model="paramsBefore[key]"
                  :label="key"
                  readonly
                  hide-details
                />
              </v-row>
            </v-col>
          </template>
        </v-col>
        <v-col cols="6">
          <v-card-title
            class="pl-0"
          >
            After
          </v-card-title>

          <template v-if="hasIbanBefore">
            <v-label>
              IBAN
            </v-label>
            <v-col cols="12">
              <v-row
                v-for="(_, key) in localModelValue.details.iban_details"
                :key="key"
              >
                <v-text-field
                  v-model="localModelValue.details.iban_details[key]"
                  :label="key"
                  :prepend-icon="infoBefore.iban_details[key] === localModelValue.details.iban_details[key] ? 'mdi-equal' : 'mdi-not-equal'"
                  hide-details
                />
              </v-row>
            </v-col>
          </template>

          <template v-if="hasParamsBefore">
            <v-label>
              Params
            </v-label>
            <v-col cols="12">
              <v-row
                v-for="(_, key) in extractParams(localModelValue.details.params)"
                :key="key"
              >
                <v-text-field
                  v-model="localModelValue.details.params[key]"
                  :label="key"
                  :prepend-icon="paramsBefore[key] === localModelValue.details.params[key] ? 'mdi-equal' : 'mdi-not-equal'"
                  hide-details
                />
              </v-row>
            </v-col>
          </template>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn
        v-if="hasBeenEditedBefore"
        color="primary"
        @click="$emit('update', { ...localModelValue, details: { ...infoBefore } })"
      >
        <v-icon>mdi-lock-reset</v-icon>
        Reset
      </v-btn>
      <v-btn
        color="error"
        :loading="isLoading"
        @click="$emit('close')"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :loading="isLoading"
        @click="$emit('update', localModelValue)"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { cloneDeep, pick, omit } from 'lodash'
import vueJsonEditor from 'vue-json-editor'

export default {
  components: {
    vueJsonEditor,
  },
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    isLoading: Boolean,
  },
  emits: ['update', 'close'],
  data() {
    return {
      localModelValue: cloneDeep(this.transaction),
      infoBefore: cloneDeep(pick(this.transaction.details._details_update_meta?.init || this.transaction.details, ['iban_details', 'params'])),
    }
  },
  computed: {
    hasBeenEditedBefore() {
      return !!this.localModelValue.details._details_update_meta
    },
    paramsBefore() {
      return omit(this.infoBefore.params, ['iov_flag', 'account', 'fp_flag', 'details', 'language'])
    },
    hasParamsBefore() {
      return !!Object.keys(this.paramsBefore).length
    },
    hasIbanBefore() {
      return !!Object.keys(this.infoBefore.iban_details || {}).length
    }
  },
  methods: {
    extractParams(params) {
      return omit(params, ['iov_flag', 'account', 'fp_flag', 'details', 'language'])
    },
  },
}
</script>
